import React, {useState, useEffect} from "react";
import CloseButton from "../../../assets/img/utils/cross-btn.svg";
import './RightSidePanel.scss';

const RightSidePanel = ({Name, ExerciseMediaUrl, PatientGuidelineContent, closeBtnCallbackFn}) => {
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false)
        }, 500);
    }, [ExerciseMediaUrl])


    return (
        <div className='right-side-panel__container'>
            <div>
                <div className="right-side-panel__guideline-container">
                    <span>Movement Guideline</span>
                    {
                        closeBtnCallbackFn
                        && (
                            <img src={CloseButton} alt="Close" className='close-button' onClick={closeBtnCallbackFn}/>
                        )
                    }
                </div>
            </div>
            <div className="right-side-panel__name-container">
                <span>{Name}</span>
            </div>
            <div className="right-side-panel__img-container right-side-panel--position-relative">
                <div
                    className="right-side-panel--h-100-percent right-side-panel--fake-spinner right-side-panel--d-flex right-side-panel--justify-center right-side-panel--align-center">
                    <i className="fa fa-spinner fa-spin"/>
                </div>
                {!isLoading ?
                    <div className={`right-side-panel--h-100-percent right-side-panel__img-wrapper`}>
                        <img
                            className="right-side-panel--h-100-percent right-side-panel--max-width-100-percent right-side-panel__img"
                            src={ExerciseMediaUrl} alt="exercise"/>
                    </div> : null
                }
            </div>
            <div className="right-side-panel__guideline-text">
                {PatientGuidelineContent}
            </div>
        </div>
    );
}

export default RightSidePanel;
